import type { FutebolEventoPartida, FutebolPartidaAtiva } from '@/shared/types';
import { isIntervaloAtivo } from '@/features/futebol';

const COOLDOWN_POS_PEDIDO_MS = 3 * 60 * 1_000;
const GOL_OVERLAY_MS         = 20_000;

export type HypeAdiadoMotivo =
  | 'pedido_cliente'
  | 'pedido_popup'
  | 'flash_ativo'
  | 'gol'
  | 'intervalo_ht'
  | 'cooldown_pedido'
  | 'fora_horario'
  | 'hype_ativo';

export interface HypeJanelaCheck {
  ok:     boolean;
  motivo?: HypeAdiadoMotivo;
}

export function minutosAgoraBRT(): number {
  const brt = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
  return brt.getHours() * 60 + brt.getMinutes();
}

export function parseHorarioParaMinutos(horario: string): number {
  const [h, m] = horario.split(':');
  return Number(h) * 60 + Number(m ?? 0);
}

export function dentroJanelaHorariaBRT(horaInicio: string, horaFim: string): boolean {
  const agora = minutosAgoraBRT();
  const inicio = parseHorarioParaMinutos(horaInicio);
  const fim    = parseHorarioParaMinutos(horaFim);
  return agora >= inicio && agora <= fim;
}

export function isGolOverlayAtivo(partida: FutebolPartidaAtiva | null): boolean {
  const ev = partida?.ultimo_evento as FutebolEventoPartida | null | undefined;
  if (!ev || ev.tipo !== 'gol') return false;
  const atualizado = partida?.updated_at ? new Date(partida.updated_at).getTime() : 0;
  return atualizado > 0 && Date.now() - atualizado < GOL_OVERLAY_MS;
}

export function avaliarJanelaHype(opts: {
  pedidoAtual:           boolean;
  showPedidoPopup:       boolean;
  flashAtivo:            boolean;
  hypeAtivo:             boolean;
  partida:               FutebolPartidaAtiva | null;
  ultimoFimPedidoCliente: number | null;
  horaInicio:            string;
  horaFim:               string;
}): HypeJanelaCheck {
  if (opts.hypeAtivo) return { ok: false, motivo: 'hype_ativo' };
  if (opts.pedidoAtual) return { ok: false, motivo: 'pedido_cliente' };
  if (opts.showPedidoPopup) return { ok: false, motivo: 'pedido_popup' };
  if (opts.flashAtivo) return { ok: false, motivo: 'flash_ativo' };
  if (isGolOverlayAtivo(opts.partida)) return { ok: false, motivo: 'gol' };
  if (opts.partida?.ultimo_evento && isIntervaloAtivo(opts.partida.ultimo_evento)) {
    return { ok: false, motivo: 'intervalo_ht' };
  }
  if (
    opts.ultimoFimPedidoCliente != null
    && Date.now() - opts.ultimoFimPedidoCliente < COOLDOWN_POS_PEDIDO_MS
  ) {
    return { ok: false, motivo: 'cooldown_pedido' };
  }
  if (!dentroJanelaHorariaBRT(opts.horaInicio, opts.horaFim)) {
    return { ok: false, motivo: 'fora_horario' };
  }
  return { ok: true };
}
